import type { ReactNode } from 'react';

/**
 * A titled section of a legal document.
 *
 * Ported from the legacy `Section` helper defined identically in
 * `pages/privacy.tsx` and `pages/terms.tsx`, extracted here so both pages
 * share one copy. It now uses the legacy shadcn theme tokens directly
 * (`border-border`, `text-muted-foreground`), which V2-VS-01A introduced and
 * V2-VS-01B activates.
 */
export function LegalSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="space-y-3">
      <h2 className="border-b border-border pb-2 text-lg font-bold">{title}</h2>
      <div className="space-y-2 text-sm leading-relaxed text-muted-foreground">
        {children}
      </div>
    </div>
  );
}
